import React from 'react';
import styled from 'styled-components';
import { getColor } from 'common/constants/_colors';
import { Flex, Padding } from 'components/base/layout-components';
import Text from 'components/base/Text';
import BoldedValue from 'components/BoldedValue';
import ArrowedBox from 'components/ArrowedBox';
import PipelineArrow from './PipelineArrow';
import Icon from './base/Icon';

const blockItemWidth = '7rem';
const PipelineBlockItem = styled(Flex)`
  height: 0.8rem;
  min-width: ${blockItemWidth};
  ${({ isFirst, color }) =>
    isFirst
      ? `border-bottom: 0.8rem solid ${getColor(color)};
     border-right: 0.55rem solid transparent;
     transform: translateY(-0.8rem);
   `
      : `
   transform: skewX(35deg);
   background: ${getColor(color)};
   margin-bottom: 0.8rem;
   margin-right: 0.28rem;
`}
`;
const PipelineInfoWrapper = styled(Flex)`
  position: relative;
  ${({ isFirst }) =>
    isFirst
      ? `
  border-left: 2px dashed ${getColor('botticelli')};
  transform: translateX(-2px);
  `
      : ``}
`;
const PipelineArrowFixed = styled(PipelineArrow)`
  position: absolute;
  transform: translateX(calc(100% - 0.5rem));
  right: 0;
`;
const RightTag = styled(ArrowedBox)`
  position: absolute;
  top: 100%;
  right: 0;
  transform: translate(calc(50% + 1rem), 2rem);
`;
const LeftTag = styled(ArrowedBox)`
  position: absolute;
  top: 100%;
  left: 0;
  transform: translate(calc(-50% - 1px), 2rem);
`;

const PipelineItem = ({
  isFirst,
  color,
  title,
  value,
  description,
  rightTag,
  leftTag,
  titleSpace,
  valueSize,
  tooltip,
  enableDescription,
  isHideNonWorkingDaysEnabled,
  isIncludeWeekends,
  isIncludedStage = true,
  ...rest
}) => {
  const textColor = tooltip ? 'osloGray' : 'shuttleGray';
  const barColor = tooltip ? 'botticelli' : color;
  const piepLineBlockItem = (
    <PipelineBlockItem isFirst={isFirst} color={barColor} />
  );

  return (
    <Flex
      width='100%'
      data-testid='pipeline-item-testid'
      direction='column'
      {...rest}
      opacity={isIncludedStage || value === 'N/A' ? '1' : '0.5'}
    >
      {tooltip ? tooltip(piepLineBlockItem) : piepLineBlockItem}
      <PipelineInfoWrapper isFirst={isFirst} justify='space-between'>
        {leftTag && <LeftTag text={leftTag} />}
        <Flex pl={isFirst ? 'small' : titleSpace} direction='column'>
          <Text color={textColor}>{title}</Text>
          <BoldedValue
            value={{ text: value, size: valueSize, color: textColor }}
            description={
              enableDescription && {
                text: description,
                size: 'small',
                color: textColor
              }
            }
          />
        </Flex>
        {isIncludeWeekends && isHideNonWorkingDaysEnabled && (
          <Padding>
            <Icon
              color='dodgerBlue'
              name='infoOutlined'
              data-testid='item-include-weekends-icon'
            />
          </Padding>
        )}
        {rightTag && <RightTag text={rightTag} />}
        <PipelineArrowFixed />
      </PipelineInfoWrapper>
    </Flex>
  );
};
export default PipelineItem;
